<template>
  <esg-table-without-meta :items="items"
                          :fields="fields"
                          max-height="300px"
                          size="sm">
    <template #thead-top>
      <tr>
        <th colspan="3"><span>제품 정보</span></th>
        <th colspan="3"><span>협력업체 정보</span></th>
        <th colspan="2"><span>거래 사업장 정보</span></th>
        <th colspan="2"><span>탄소 코스트 정보</span></th>
      </tr>
    </template>
    <template #cell(values)="data">
      <td class="text-center align-middle"
          :style="{ color: !data.value ? 'black' : (data.value >= 0 ? 'red' : 'blue') }">
        {{ formatChangeRate(data.value) }}
      </td>
    </template>
  </esg-table-without-meta>
</template>

<script>
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  name: "TransportationPartnerDetail",
  components: { EsgTableWithoutMeta },
  props: {
    type: {
      type: String,
      default: 'upstream'
    },
    year: {
      type: Number,
    },
    product: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      fields: [
        {
          name: 'product_family_name',
          label: '제품군',
          list: true,
        },
        {
          name: 'product_name',
          label: '제품명',
          list: true,
        },
        {
          name: 'product_code',
          label: '제품코드',
          list: true,
        },
        {
          name: 'partner_code',
          label: '관리번호',
          list: true,
          sortable: true
        },
        {
          name: 'partner_name',
          label: '협력업체',
          list: true,
          sortable: true
        },
        {
          name: 'values',
          label: '전년비 증감',
          formatter: val => val ? this.formatNumber(val) + '%' : '-',
          list: true,
          sortable: true
        },
        {
          name: 'main_business_location_code',
          label: '사업코드',
          list: true,
        },
        {
          name: 'main_business_location_name',
          label: '주거래 사업장',
          list: true,
        },
        {
          name: 'supply_price',
          label: '총 공급가액\n(단위: 천원)',
          list: true,
        },
        {
          name: 'emission_per_unit_price',
          label: '천원당 배출량',
          list: true,
        },
      ]
    }
  },
  watch: {
    product: {
      deep: true,
      immediate: true,
      handler() {
        this.fetchData();
      }
    },
    year: {
      immediate: true,
      handler() {
        this.fetchData();
      }
    }
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchData() {
      if (!this.product || !this.product.productFamilyCode || !this.product.productCode || !this.product.name) return
      if (!this.year) return;

      try {
        this.loading = true;

        let args = [{
          years: [this.year - 1, this.year],
          productFamilies: [this.product.productFamilyCode],
          products: [this.product.productCode],
          groupKeys: ['year', 'product_family_name', 'product_name', 'product_code', 'partner_code', 'partner_name']
        }]

        let data = new FormData()
        data.append('path', `esg/lca/${this.type}_transportation_detail/main`);
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        // If there is no data, return
                if (!response.data.data) {
          this.series = [];
          return;
        }


        // Parse JSON data
        let tableData = JSON.parse(response.data.data)[0].data;

        tableData.forEach(row => {
          // If the year is the current year, calculate the change rate
          if (row.year === this.year) {
            let partnerCode = row.partner_code;
            let prevYear = tableData.find(row => (row.year === this.year - 1) && row.partner_code === partnerCode);
            if (prevYear) {
              row.values = 100 * (row.values - prevYear.values) / prevYear.values;
            } else {
              row.values = null
            }
          }
        });

        this.items = tableData.filter(row => row.year === this.year);

        // 더미 데이터 추가
        this.items.forEach(item => {
          item.main_business_location_code = '1100';
          item.main_business_location_name = '울산고무공장';
          item.supply_price = Number(new Date().getTime().toString().slice(-4));
          item.emission_per_unit_price = Number(new Date().getTime().toString().slice(-4));
        });

      } catch (error) {
        await this.showError(error);
      }
    },
    formatChangeRate(value) {
      if (value) {
        return (value >= 0 ? '▲' : '▼') + this.formatNumber(value, 0) + '%'
      } else {
        return '-'
      }
    }
  }
}
</script>

<style scoped>
>>> .table.custom-table.table-sm td,
>>> .table.custom-table.table-sm th {
  font-size: .875rem !important;
  padding: .4rem 0;
}
</style>